import { type RouteRecordRaw, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/f/:tenantId/:formId',
        component: () => import('./forms.vue')
    },
    {
        path: '/a/:token',
        component: () => import('./appointments.vue')
    }
];

// The customer-facing links above are served from the root of this app's own deployment (dist-cx).
// Dev and the e2e preview build serve every app from one root, where this entry keeps its in-project
// path (…/embedded/cx/index.html) and a real route path can't be resolved — so route by hash there.
// Keyed off where the document actually came from rather than `import.meta.env.DEV`, because the
// visual suite drives a production build and reaches these routes by their real paths (see
// `cxEmbeddedRoutingPlugin` in vite.config.ts).
const servedFromEntryPath = window.location.pathname.includes('/embedded/cx/');

const router = createRouter({
    history: servedFromEntryPath ? createWebHashHistory() : createWebHistory(),
    routes
});

export default router;
